<script setup lang="ts">
import { useUserStore } from '@/stores/user'

definePageMeta({
  layout: 'auth',
  middleware: ['auth'],
  requireLogin: false,
})
useHead({
  title: 'login',
})

const userStore = useUserStore()
const runtimeConfig = useRuntimeConfig()

onMounted(() => {})
</script>

<template>
  <div
    :class="`${
      runtimeConfig.public.source == 'customer'
        ? 'login-customer bg-landing-orange'
        : ''
    }`"
  >
    <LoginTwo v-if="runtimeConfig.public.source == 'customer'" />
    <LoginFirst v-else />
  </div>
</template>

<style lang="scss"></style>
